import Approvals from '../../approval/ApprovalsContainer';
import Changelog from '../../changelog/Changelog';
import Comments from '../../comments/CommentsState';

export const approval = props => ({
  label: 'Approval',
  key: 'approval',
  contentComponent: Approvals,
  props,
});

export const comments = props => ({
  label: 'Comments',
  key: 'comments',
  contentComponent: Comments,
  props: {
    key: `comments of ${props.contentType}:${props.objectId}`,
    ...props,
  },
  expandable: true,
});

export const changelog = props => ({
  label: 'Activity',
  key: 'changelog',
  contentComponent: Changelog,
  props,
  expandable: true,
});
